// I. SITE METADATA & SEO
// --------------------------------------------------
// Used for branding, page titles, and meta tags.

export const SITE_NAME = "PrivateMovieZ";
export const SITE_TITLE = `${SITE_NAME} - Download 4K UHD Movies & TV Shows | BluRay REMUX, Dolby Vision`;
export const SITE_DESCRIPTION = "Download top-quality movies & TV series in 4K UHD, 1080p, BluRay REMUX, HDR10, Dolby Vision & Atmos from fast Google Drive servers. Free, no registration.";
export const AUTHOR_NAME = "TeamPMZ";
export const AUTHOR_URL = "https://PrivateMovieZBot.t.me"; // Optional: Add author's URL here. Leave empty ("") to display only text.


// II. DOMAIN & URLS
// --------------------------------------------------
// Central management of all domains and primary URLs.

export const DOMAIN = "go.privatemoviez.blog";
export const BASE_URL = "https://privatemoviez.blog";
export const TELEGRAM_URL = "https://t.me/PMZNetwork";


// III. APPLICATION BEHAVIOR
// --------------------------------------------------
// Constants that control animations, delays, and other dynamic behaviors.

/** 
 * The delay in milliseconds before redirecting the user.
 * @see /context/RedirectContext.tsx
 */
export const REDIRECT_DELAY_MS = 2000;


/**
 * The intersection observer threshold for triggering the reveal animation.
 * @see /components/Reveal.tsx
 */
export const REVEAL_ANIMATION_THRESHOLD = 0.05;


// IV. UI CONTENT & TEXT
// --------------------------------------------------
// Centralized strings for key UI elements.

export const HEADER_TAGLINE = `Your Gateway to High-Speed Movie & TV Show Downloads — Only on ${SITE_NAME}`;
export const PRIMARY_CTA_TEXT = "Visit Site";


// V. SEO & STRUCTURED DATA
// --------------------------------------------------
// Settings for structured data, meta tags, and icons.

export const SITE_ALTERNATE_NAME: string[] = ["PMZ", "PMS", "private moviez", "privatemovies", "private movies", "privatemoviesz", "privetmoviez", "piratemoviez", "privatemoviz", "privatmovies", "privatemovie", "private movie", "privetmoviz", "private moviz", "privatemiviez", "private movies z", "privatmoviz", "privetmoviesz", "privatemoviez.fun", "privatemociez", "priavtemoviez", "privatemoviezz", "privatemovuez", "privatemovez", "privetemoviez", "privatemoviex", "private moviez.com", "provatemoviez", "privat movies", "privatemobiez", "privtemoviez", "privatezmovies"];
export const SITE_LOCALE = "en_US"; // e.g., en_US, en_GB, etc.
// A representative logo for the brand. Used in Open Graph, structured data, and as a favicon.
// Must be a real hosted image URL for Google's Schema validation (data URIs are rejected).
export const SITE_LOGO_URL = `${BASE_URL}/Image/PrivateMovieZ.webp`;

// Social media profiles for the `Organization` schema.
export const SOCIAL_PROFILES = {
    telegram: TELEGRAM_URL,
    github: AUTHOR_URL,
};

// VI. THIRD-PARTY INTEGRATIONS
// --------------------------------------------------

/**
 * Your Google Analytics Tracking ID.
 * @example "G-XXXXXXXXXX"
 * Leave empty to disable Google Analytics.
 */
export const GOOGLE_ANALYTICS_ID: string = "G-0VLNWTE7DV";
export const GOOGLE_SITE_VERIFICATION_ID: string = "hMoo_LAzulJ3G1BYiyAqDwH-8xZSdlBI4XQSDra3Z7U";


// VII. SEO & INDEXING
// --------------------------------------------------
/**
 * Controls search engine indexing.
 * Set to `true` for production to allow Google to index the site.
 * Set to `false` during development or testing to prevent indexing.
 * This will generate a `<meta name="robots" content="noindex, nofollow">` tag.
 */
export const ENABLE_SEO_INDEXING: boolean = true;
